import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Trending.svg'

export const IconTrending = IconSVG as IconComponent
